export default __webpack_public_path__ + "static/media/push33.27a0ffc3.gif";